// extracted by mini-css-extract-plugin
export default {"build":"Build_build__0yQyK","button":"Build_button__vYLMj","h2":"Build_h2__ZcueI","description":"Build_description__xmeiR"};